module.exports = __webpack_public_path__ + "d60a042e2c757a0c9bb94c923e7d752b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/browsers/chrome.svg
// module id = ihXi
// module chunks = 27